<template>
	<div class="data-table__expandable-section" :class="{ 'data-table__expandable-section--expanded': expanded }">
		<div class="data-table__expandable-section-header" :data-test="dataTestName" @click="toggleExpanded()">
			<DataTableRow>
				<div class="data-table__cell data-table__cell--row-title" :class="{ 'ml-150': alignRowTitle }">
					<span
						class="display-flex align-items-center"
						:class="{ 'font-weight-bold heading-text-color': expanded }"
					>
						<BaseSvgIcon name="chevron" width="24" height="24" :dir="expanded ? 'up' : 'down'" />
						<div class="ml-100">
							<slot name="row-title" />
						</div>
					</span>
				</div>
				<slot v-if="showHeaderContent" name="row-title-content">
					<DataTableCell>&nbsp;</DataTableCell>
				</slot>
				<slot v-else name="row-title-content-static" />
			</DataTableRow>
		</div>
		<TransitionCollapse>
			<div v-if="expanded" class="data-table__expandable-section-content" :class="{ 'pl-0': noLeftPadding }">
				<slot name="row-expanded-content" />
			</div>
		</TransitionCollapse>
	</div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import DataTableCell from '@components/account/data-table-cell.vue';
import DataTableRow from '@components/account/data-table-row.vue';
import TransitionCollapse from '@components/layout/transition-collapse.vue';
interface Props {
	alignRowTitle?: boolean;
	fadeHeaderContent?: boolean;
	noLeftPadding?: boolean;
	openByDefault?: boolean;
	dataTestName?: string;
}
const props = withDefaults(defineProps<Props>(), {
	alignRowTitle: false,
	fadeHeaderContent: false,
	noLeftPadding: false,
	openByDefault: false,
	dataTestName: 'expandable-table-row'
});

const expanded = ref(false);

const showHeaderContent = computed((): boolean => {
	return props.fadeHeaderContent ? !expanded.value : true;
});

watch(
	() => props.openByDefault,
	() => {
		expanded.value = props.openByDefault;
	}
);

function toggleExpanded(): void {
	expanded.value = !expanded.value;
}

function setup(): void {
	expanded.value = props.openByDefault;
}
setup();
</script>
